import BaseContainer from "@components/ui/BaseContainer";
import useProjectContext from "@utils/hooks/context/useProjectContext";
import classes from "./Projects.module.scss";
import Project from "./Project";

const Projects = () => {
  const { project } = useProjectContext();

  return (
    <BaseContainer className={classes.projects}>
      <ul className={classes.works}>
        {project.projects.map((work) => (
          <Project work={work} key={work.id} />
        ))}
      </ul>
    </BaseContainer>
  );
};

export default Projects;
